import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Checkbox, Gap, theme } from '@salecycle/ui-component-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faLock } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ExitIntentAreas } from 'sections/onsite-campaigns/types';

const OuterBox = styled.div`
  background-color: #586874;
  width: 800px;
  height: 476px;
  border: 4px solid ${theme.vars.newColor.black};
  border-radius: 8px;
`;

interface AreaSelectedProps {
  isSelected?: boolean;
}

const TopBarBox = styled.div`
  background-color: #a2afb8;
  width: 792px;
  height: 38px;
  border-radius: 8px 8px 0px 0px;
  display: flex;
`;

const FirstApplicationControlDot = styled.div`
  background: #1d2226;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: relative;
  top: 14px;
  left: 21px;
`;

const SecondApplicationControlDot = styled.div`
  background: #1d2226;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: relative;
  top: 14px;
  left: 29px;
`;

const ThirdApplicationControlDot = styled.div`
  background: #1d2226;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: relative;
  top: 14px;
  left: 37px;
`;

const ArrowsContainer = styled.div`
  width: 90px;
  position: relative;
  top: 10px;
  left: 80px;
`;

const TopLeftBox = styled.div<AreaSelectedProps>`
  float: left;
  margin-left: 81px;
  padding-left: 2px;
  clear: left;
  background: ${({ theme }) => theme.vars.newColor.white};
  width: 311px;
  height: 72px;
  border: ${({ isSelected }) => (isSelected ? `2px solid ${theme.vars.newColor.blue1}` : '')};
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  cursor: pointer;

  &:hover {
    background: #cce3ff;
  }
`;

const TopRightBox = styled.div<AreaSelectedProps>`
  float: right;
  margin-right: 81px;
  padding-right: 2px;
  background: ${({ theme }) => theme.vars.newColor.white};
  width: 311px;
  height: 72px;
  border: ${({ isSelected }) => (isSelected ? `2px solid ${theme.vars.newColor.blue1}` : '')};
  display: flex;
  align-items: center;
  text-align: center;
  cursor: pointer;

  &:hover {
    background: #cce3ff;
  }
`;

const FloatRightText = styled.div<AreaSelectedProps>`
  position: relative;
  left: 118px;
`;

const LeftTopBox = styled.div<AreaSelectedProps>`
  float: left;
  margin-bottom: 2px;
  padding-left: 2px;
  clear: left;
  background: ${({ theme }) => theme.vars.newColor.white};
  margin-left: 0;
  width: 80px;
  height: 140px;
  border: ${({ isSelected }) => (isSelected ? `2px solid ${theme.vars.newColor.blue1}` : '')};
  display: flex;
  align-items: center;
  text-align: center;
  cursor: pointer;

  &:hover {
    background: #cce3ff;
  }
`;

const RightTopBox = styled.div<AreaSelectedProps>`
  float: right;
  background: ${({ theme }) => theme.vars.newColor.white};
  margin-bottom: 2px;
  padding-left: 2px;
  border: ${({ isSelected }) => (isSelected ? `2px solid ${theme.vars.newColor.blue1}` : '')};
  width: 80px;
  height: 140px;
  display: flex;
  align-items: center;
  text-align: center;
  cursor: pointer;

  &:hover {
    background: #cce3ff;
  }
`;

const LeftBottomBox = styled.div<AreaSelectedProps>`
  float: left;
  margin-top: 2px;
  padding-left: 2px;
  clear: left;
  background: ${({ theme }) => theme.vars.newColor.white};
  border: ${({ isSelected }) => (isSelected ? `2px solid ${theme.vars.newColor.blue1}` : '')};
  width: 80px;
  height: 140px;
  display: flex;
  align-items: center;
  text-align: center;
  cursor: pointer;

  &:hover {
    background: #cce3ff;
  }
`;

const RightBottomBox = styled.div<AreaSelectedProps>`
  margin-top: 2px;
  padding-left: 2px;
  float: right;
  background: ${({ theme }) => theme.vars.newColor.white};
  border: ${({ isSelected }) => (isSelected ? `2px solid ${theme.vars.newColor.blue1}` : '')};
  width: 80px;
  height: 140px;
  display: flex;
  align-items: center;
  text-align: center;
  cursor: pointer;

  &:hover {
    background: #cce3ff;
  }
`;

const BottomLeftBox = styled.div<AreaSelectedProps>`
  float: left;
  margin-left: 81px;
  padding-left: 2px;
  clear: left;
  background: ${({ theme }) => theme.vars.newColor.white};
  border: ${({ isSelected }) => (isSelected ? `2px solid ${theme.vars.newColor.blue1}` : '')};
  width: 311px;
  height: 72px;
  display: flex;
  align-items: center;
  text-align: center;
  cursor: pointer;

  &:hover {
    background: #cce3ff;
  }
`;

const BottomRightBox = styled.div<AreaSelectedProps>`
  float: right;
  margin-right: 81px;
  padding-right: 2px;
  background: ${({ theme }) => theme.vars.newColor.white};
  border: ${({ isSelected }) => (isSelected ? `2px solid ${theme.vars.newColor.blue1}` : '')};
  width: 311px;
  height: 72px;
  display: flex;
  align-items: center;
  text-align: center;
  cursor: pointer;

  &:hover {
    background: #cce3ff;
  }
`;

const AddressBarBox = styled.div`
  width: 415px;
  height: 25px;
  position: relative;
  background: ${({ theme }) => theme.vars.newColor.white};
  top: 7px;
  left: 49px;
  border-radius: 4px 4px 0px 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
`;

export type ExitIntentSelectorProps = {
  value: ExitIntentAreas[];
  onChange: (intent: ExitIntentAreas) => void;
  selectAllExitIntent: () => void;
  unselectAllExitIntent: () => void;
};

export function ExitIntentAreaSelector({
  value,
  onChange,
  selectAllExitIntent,
  unselectAllExitIntent,
}: ExitIntentSelectorProps) {
  const exitIntentContainsArea = useCallback((area: ExitIntentAreas): boolean => value.includes(area), [value]);

  const [allSelected, setAllSelected] = useState(false);
  const onAllSelected = useCallback(() => {
    const flippedValue = !allSelected;
    setAllSelected(flippedValue);
    if (flippedValue) {
      selectAllExitIntent();
    } else {
      unselectAllExitIntent();
    }
  }, [allSelected, selectAllExitIntent, unselectAllExitIntent]);

  useEffect(() => {
    if (Object.values(ExitIntentAreas).length > value.length) {
      setAllSelected(false);
    } else {
      setAllSelected(true);
    }
  }, [value.length]);

  return (
    <>
      <Checkbox
        id="select-all"
        label="Select all"
        aria-label="Select all"
        checked={allSelected}
        onChange={onAllSelected}
      />
      <Gap bottom={34} />
      <OuterBox aria-label="Exit intent hotspots">
        <TopBarBox>
          <FirstApplicationControlDot />
          <SecondApplicationControlDot />
          <ThirdApplicationControlDot />
          <ArrowsContainer>
            <FontAwesomeIcon icon={faChevronLeft as IconProp} style={{ fontSize: 20 }} />
            <FontAwesomeIcon icon={faChevronRight as IconProp} style={{ fontSize: 20, paddingLeft: 18 }} />
          </ArrowsContainer>
          <AddressBarBox>
            <FontAwesomeIcon icon={faLock as IconProp} style={{ paddingLeft: 180, paddingRight: 8 }} />
            https://
          </AddressBarBox>
        </TopBarBox>
        <TopLeftBox
          aria-label="Top left"
          onClick={() => onChange(ExitIntentAreas.TopLeft)}
          isSelected={exitIntentContainsArea(ExitIntentAreas.TopLeft)}
        >
          <FloatRightText>
            <Checkbox
              id="top-left-checkbox"
              checked={exitIntentContainsArea(ExitIntentAreas.TopLeft)}
              onChange={() => onChange(ExitIntentAreas.TopLeft)}
              label="top-left"
              aria-label="Top left checkbox"
            />
          </FloatRightText>
        </TopLeftBox>
        <TopRightBox
          aria-label="Top right"
          onClick={() => onChange(ExitIntentAreas.TopRight)}
          isSelected={exitIntentContainsArea(ExitIntentAreas.TopRight)}
        >
          <FloatRightText>
            <Checkbox
              id="top-right-checkbox"
              checked={exitIntentContainsArea(ExitIntentAreas.TopRight)}
              onChange={() => onChange(ExitIntentAreas.TopRight)}
              label="top-right"
              aria-label="Top right checkbox"
            />
          </FloatRightText>
        </TopRightBox>
        <LeftTopBox
          aria-label="Left top"
          onClick={() => onChange(ExitIntentAreas.LeftTop)}
          isSelected={exitIntentContainsArea(ExitIntentAreas.LeftTop)}
        >
          <Checkbox
            id="left-top-checkbox"
            checked={exitIntentContainsArea(ExitIntentAreas.LeftTop)}
            onChange={() => onChange(ExitIntentAreas.LeftTop)}
            label="left-top"
            aria-label="Left top checkbox"
          />
        </LeftTopBox>
        <RightTopBox
          aria-label="Right top"
          onClick={() => onChange(ExitIntentAreas.RightTop)}
          isSelected={exitIntentContainsArea(ExitIntentAreas.RightTop)}
        >
          <Checkbox
            id="right-top-checkbox"
            checked={exitIntentContainsArea(ExitIntentAreas.RightTop)}
            onChange={() => onChange(ExitIntentAreas.RightTop)}
            label="right-top"
            aria-label="Right top checkbox"
          />
        </RightTopBox>
        <LeftBottomBox
          aria-label="Left bottom"
          onClick={() => onChange(ExitIntentAreas.LeftBottom)}
          isSelected={exitIntentContainsArea(ExitIntentAreas.LeftBottom)}
        >
          <Checkbox
            id="left-bottom-checkbox"
            checked={exitIntentContainsArea(ExitIntentAreas.LeftBottom)}
            onChange={() => onChange(ExitIntentAreas.LeftBottom)}
            label="left-bottom"
            aria-label="Left bottom checkbox"
          />
        </LeftBottomBox>
        <RightBottomBox
          aria-label="Right bottom"
          onClick={() => onChange(ExitIntentAreas.RightBottom)}
          isSelected={exitIntentContainsArea(ExitIntentAreas.RightBottom)}
        >
          <Checkbox
            id="right-bottom-checkbox"
            checked={exitIntentContainsArea(ExitIntentAreas.RightBottom)}
            onChange={() => onChange(ExitIntentAreas.RightBottom)}
            label="right-bottom"
            aria-label="right bottom checkbox"
          />
        </RightBottomBox>
        <BottomLeftBox
          aria-label="Bottom left"
          onClick={() => onChange(ExitIntentAreas.BottomLeft)}
          isSelected={exitIntentContainsArea(ExitIntentAreas.BottomLeft)}
        >
          <FloatRightText>
            <Checkbox
              id="bottom-left-checkbox"
              checked={exitIntentContainsArea(ExitIntentAreas.BottomLeft)}
              onChange={() => onChange(ExitIntentAreas.BottomLeft)}
              label="bottom-left"
              aria-label="Bottom left checkbox"
            />
          </FloatRightText>
        </BottomLeftBox>
        <BottomRightBox
          aria-label="Bottom right"
          onClick={() => onChange(ExitIntentAreas.BottomRight)}
          isSelected={exitIntentContainsArea(ExitIntentAreas.BottomRight)}
        >
          <FloatRightText>
            <Checkbox
              id="bottom-right-checkbox"
              checked={exitIntentContainsArea(ExitIntentAreas.BottomRight)}
              onChange={() => onChange(ExitIntentAreas.BottomRight)}
              label="bottom-right"
              aria-label="Bottom right checkbox"
            />
          </FloatRightText>
        </BottomRightBox>
      </OuterBox>
    </>
  );
}
